import React from "react";
import logo from "../../../../../../assets/image/logo.png";
import { Link } from "react-router-dom";
import amazing_value from "../../../../../../assets/image/Amazing-Value.png";
import expert_service from "../../../../../../assets/image/Expert-Service.png";
import fast_shipping from "../../../../../../assets/image/fast-delivery.png";
import Unbeatable from "../../../../../../assets/image/Unbeatable-Selection.png";
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaLinkedinIn } from "@react-icons/all-files/fa/FaLinkedinIn";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube";
import { FaXTwitter } from "react-icons/fa6";
import { LocateIcon, MailCheck, MailIcon, Phone, PhoneCall } from "lucide-react";
const quickLinks = [
  { name: "Home", link: "/homepage" },
  { name: "Shop", link: "/shop" },
  { name: "Services", link: "/our-services" },
  { name: "About Us", link: "/about-us" },
  { name: "Blogs", link: "/blog" },
  { name: "Contact Us", link: "/contact-us" },
];
const impLinks = [
  { name: "My Account", link: "/account/dashboard" },
  { name: "Wishlist", link: "/account/wishlist" },
  { name: "Privacy Policy", link: "/privacy-policy" },
  { name: "Cancellation and Return  Policy", link:"/order-cancel" },
  // { name: "Return Policy", link: "" },
];
export default function Footer() {
  return (
    <div>
      <div className="bg-[#034C8C] w-full">
        <div className="container bg-[#034C8C] text-white  lg:py-8 md:py-8 py-4 w-full flex flex-wrap justify-between">
          <div className="flex items-center  md:items-start flex-col space-5 w-full md:w-64 lg:px-[45px]  md:mb-0 md:text-left text-center md:border-0 border-b-4 border-white ">
            <img
              src={expert_service}
              alt="expert_service"
              className="md:h-20 h-16 ps-2  mb-2 "
              style={{ position: "relative" }}
            />
            <div className="lg:text-start sm:text-center  md:text-start ">
              <h4 className="font-bold">Expert Service</h4>
              <p className="text-lg md:mb-2 lg:text-start ">
                Our friendly team is available seven days a week to assist you.
              </p>
            </div>
          </div>
          <div className="flex items-center md:items-start flex-col space-5 w-full md:w-64  md:mb-0 md:text-left text-center md:border-0 border-b-4 border-white">
            <img
              src={amazing_value}
              alt="amazing_value"
              className="h-20 ps-2 mb-2 top-space"
              style={{ position: "relative" }}
            />
            <div className="lg:text-start sm:text-center md:text-start ">
              <h4 className="font-bold ">Amazing Value</h4>
              <p className="text-lg md:mb-0">
                Shop the brands you trust at prices that fit your budget.{" "}
              </p>
            </div>
          </div>
          <div className="flex items-center md:items-start flex-col space-5 w-full md:w-64  md:mb-0 md:text-left text-center md:border-0 border-b-4 border-white ">
            <img
              src={fast_shipping}
              alt="fast_shipping"
              className="h-20 ps  mb-2 top-space"
              style={{ position: "relative" }}
            />
            <div className="lg:text-start sm:text-center md:text-start ">
              <h4 className="font-bold">Fast & Free Shipping</h4>
              <p className="text-lg md:mb-0">
                Get your orders delivered in 1-3 business days.{" "}
              </p>
            </div>
          </div>
          <div className="flex items-center md:items-start flex-col lg:pr-6 space-4 w-full md:w-64  md:mb-0 md:text-left text-center md:border-0 ">
            <img
              src={Unbeatable}
              alt="Unbeatable"
              className="h-20 ps   top-space"
              style={{ position: "relative" }}
            />
            <div className="lg:text-start md:text-start sm:text-center">
              <h4 className="font-bold">Unbeatable Selection</h4>
              <p className="text-base mb-0">
                Find everything your car needs in one convenient place.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-black text-white py-10 px-6 md:px-10 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Col 4: About + Social Icons */}
          <div className="md:col-span-4 space-y-4 lg:px-14">
            <img src={logo} alt="Vancouver Auto Parts" className="h-10" />
            <p className="text-md leading-relaxed">
              Locally owned and operated and proudly serving the Lower Mainland
              since 1987, Vancouver Auto Parts offers a great selection of auto
              parts and services at low prices.
            </p>
            {/* <div className="flex space-x-3 mt-2">
              {[
                FaFacebookF,
                FaInstagram,
                FaLinkedinIn,
                FaXTwitter,
                FaYoutube,
              ].map((Icon, index) => (
                <div
                  key={index}
                  className="p-2 border border-white rounded hover:bg-white hover:text-black transition"
                >
                  <Icon className="text-lg" />
                </div>
              ))}
            </div> */}
          </div>

          {/* Col 2: Quick Links */}
          <div className="md:col-span-2 space-y-2">
            <h3 className="text-2xl font-bold ">Quick Links</h3>
            {quickLinks.map((link, i) => (
              <Link
                to={link.link}
                key={i}
                className="block font-semibold hover:underline"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Col 2: Important Links */}
          <div className="md:col-span-3 space-y-2">
            <h3 className="text-2xl font-bold">Important Links</h3>
            {impLinks.map((link, i) => (
              <Link
                to={link.link}
                key={i}
                className="block font-semibold hover:underline"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Col 4: Connect with Us */}
          <div className="md:col-span-3 space-y-2 lg:pr-2">
            <h3 className="text-2xl font-bold text-yellow-500 ">
              Connect with Us
            </h3>
            <div className="mb-4 ">
              <p className="flex items-center mb-3">
                <LocateIcon className="mr-2" /> 10509 135a St, Surrey, BC V3T
                4C9{" "}
              </p>
              <p className="flex items-center mb-3">
                <LocateIcon className="mr-2" />
              2098 Commercial Dr, Vancouver, BC V5N 4B2
              </p>
              <p className="flex items-center mb-3">
                <LocateIcon className="mr-2" />
               2910 St Johns St, Port Moody, BC V3H 2C3
              </p>
              <p className="flex items-center mb-3">
                <PhoneCall className="mr-2" />
                <a
                  href="tel:+16045815464"
                  className=" hover:text-yellow-400 transition"
                >

                  Surrey 604-581-5464
                </a>
              </p>
              <p className="flex items-center mb-3">
                <PhoneCall className="mr-2" />
                <a
                  href="tel:+16045815464"
                  className=" hover:text-yellow-400 transition"
                >
                  Vancouver 
                  604-251-9060
                </a>
              </p>
              <p className="flex items-center mb-3">
                <PhoneCall className="mr-2" />
                <a
                  href="tel:+16045815464"
                  className=" hover:text-yellow-400 transition"
                >

                  Port Moody
                  604-461-2999 </a>
              </p>
           
              <p className="flex items-center mb-3">
                <MailCheck className="mr-2" />{" "}
                <a
                  href="mailto:info@vapautoparts.ca"
                  onClick={(e) => {
                    setTimeout(() => {
                      window.open(
                        "https://mail.google.com/mail/?view=cm&to=info@vapautoparts.ca",
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }, 500);
                  }}
                  className=" hover:text-yellow-400 transition cursor-pointer"
                >
                  info@vapautoparts.ca
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
      <div className="flex bg-gray-900 py-2 text-gray-500 ">
        <p className="mb-0 ml-2 text-center w-full">
          © 2024 Vancouver Auto Parts. All Rights Reserved
        </p>
      </div>
    </div>
  );
}
